module.exports = __webpack_public_path__ + "img/list-active.6ddb2f0c.svg";